import { Box, Flex, useMediaQuery } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import FullScreenLoader from 'components/FullScreenLoader';
import { useBloxBlockPageTitle } from 'hooks/useBloxDocumentTitle';
import NavigationHeader from 'pages/NavigationHeader';
import { HEADER_HEIGHT } from 'projectConstants';
import {
  getExandSideInputStatus,
  handleExpandSideInput,
  resetBuilderBlockTableData,
} from 'redux/BuilderModeSlice';
import {
  FetchFormulaList,
  FetchPlannerModeBlock,
  FetchPlannerModeModel,
  FetchScenarios,
  getPlannerBlock,
  getPlannerModel,
  getToggleInputPanel,
  resetBlockTableData,
} from 'redux/PlannerModeSlice';
import { AppDispatch } from 'utils/GlobalHelpers';
import { BuilderModeV1IndicatorIconProvider } from 'pages/BuilderModeV1/icons/BuilderModeV1IndicatorIconContext';

import PlannerModeHeader from './Header';
// import IndicatorPage from './IndicatorPage';
import BuilderModeTable from './Table';
import PlannerModeToolbar from './Toolbar';
import IndicatorPageOPZ from './IndicatorPageOPZ';

const BuilderMode: React.FC = () => {
  const { modelId, blockId } = useParams();
  const modelIdFromParameters = useParams().modelId;
  const [loader, setLoader] = useState(true);
  const toggleInputPanel = useSelector(getToggleInputPanel);
  const dispatch: AppDispatch = useDispatch();
  const blockDetails = useSelector(getPlannerBlock);
  const plannerModel = useSelector(getPlannerModel);
  const isExpand = useSelector(getExandSideInputStatus);

  const [isTablet] = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    const initialData = async () => {
      setLoader(true);
      dispatch(resetBlockTableData());
      dispatch(resetBuilderBlockTableData());
      dispatch(FetchPlannerModeModel(Number(modelId)));
      dispatch(FetchFormulaList(Number(modelId)));
      dispatch(FetchPlannerModeBlock(Number(blockId))).then(async () => {
        if (modelIdFromParameters) await dispatch(FetchScenarios(modelIdFromParameters));
        setLoader(false);
      });
    };
    initialData();
  }, [blockId, modelId, modelIdFromParameters]);

  useBloxBlockPageTitle(loader ? undefined : blockDetails?.name, plannerModel?.name, 'Builder');

  useEffect(() => {
    return () => {
      dispatch(handleExpandSideInput(false));
    };
  }, []);

  if (loader) {
    return <FullScreenLoader height={`calc(100vh - ${HEADER_HEIGHT})`} />;
  }

  return (
    <Box px={isTablet ? 4 : 7} py={4}>
      <NavigationHeader />
      <BuilderModeV1IndicatorIconProvider value={false}>
        <Flex
          width={'100%'}
          h={`calc(100vh - 76px)`}
          gap={4}
          flexDirection={isExpand ? 'row-reverse' : 'row'}
        >
          <Box
            width={toggleInputPanel ? (isExpand && toggleInputPanel ? '0%' : '75%') : '100%'}
            h={'100%'}
            display={isExpand ? 'none' : 'block'}
          >
            <PlannerModeHeader />
            <PlannerModeToolbar />
            <Box h={'100%'}>
              <BuilderModeTable />
            </Box>
          </Box>
          {toggleInputPanel && (
            <Box
              mt={4}
              className={`input-panel${toggleInputPanel ? ' visible' : ' hidden'}`}
              width={toggleInputPanel ? (isExpand && toggleInputPanel ? '100%' : '25%') : '0'}
              boxShadow={'1px 1px 10px #2b2727'}
              backgroundColor={'#776dcf'}
              borderRadius={'10px'}
            >
              <IndicatorPageOPZ />
            </Box>
          )}
        </Flex>
      </BuilderModeV1IndicatorIconProvider>
    </Box>
  );
};

export default withLDConsumer()(BuilderMode);
